var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-select",attrs:{"name":"ArrangementType"},on:{"change":_vm.change}},_vm._l((_vm.options),function(option,index){return _c('option',{key:index,domProps:{"value":option.kode,"selected":_vm.selectedOption(option)}},[_vm._v(" "+_vm._s(option.tekst)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }